import React from 'react'
import { Link } from 'react-router-dom'
// import PropTypes from 'prop-types'
import './PatientSelector.css'
import withPolyglot from '../../../common/withPolyglot'
import { getAgeDescription } from '../../../../resources/utilities'

// const femaleIcon = 'http://www.iconarchive.com/download/i89176/icons8/ios7/Users-User-Female.ico'

const PatientItem = ({ patient, selectPatient, match, translate }) => {
  return (
    <li className='patient-list-item'>
      <Link to={`${match.url}/${patient.id}`} onClick={() => selectPatient(patient.id.toString())}>
        <div data-uk-grid className='uk-width-1-1 patient-row'>
          <div className='uk-width-auto uk-vertical-align patient-image'>
            {<img className='patient-img' src={patient.photo} alt={translate('patient')} />}
          </div>
          <div className='uk-width-expand'>
            <div data-uk-grid className='details'>
              <div className='uk-width-2-3'>{patient.name}</div>
              <div className='uk-width-1-3 uk-text-right'>{getAgeDescription(patient.birthDate, translate)}</div>
            </div>
          </div>
        </div>
      </Link>
    </li>
  )
}

const PatientList = (props) => {
  return (
    <ul className='patient-list uk-list uk-list-striped'>
      <div className='uk-padding-small uk-text-left uk-text-large uk-text-bold'>
        {props.translate('recent')}
      </div>
      {props.patients.map((patient, index) => {
        return <PatientItem
          {...props}
          patient={patient}
          key={index}
        />
      })}
    </ul>
  )
}
export default withPolyglot(PatientList, 'patientList')
